import React, { Component } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import API from "../../api/axios"

class MonthlyEarnings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      options: {
        colors: ["#7a6fbe", "#29B6F6", "#66BB6A", "#FFA726"],
        chart: { type: "area", stacked: false, toolbar: { show: false } },
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 2 },
        grid: { borderColor: "#f8f8fa" },
        xaxis: { type: "category", categories: [] },
        legend: { show: true },
      },
      series: [],
      loading: true,
    }
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await API.get(
        "/appointments/service-per-day",
        { headers: { Authorization: `Bearer ${token}` } }
      )

      const data = response.data

      // Collect unique dates (x-axis)
      const dates = [...new Set(data.map((d) => d.date))].sort()

      // Collect unique services
      const services = [...new Set(data.map((d) => d.service))]

      // Build series data
      const series = services.map((service) => ({
        name: service,
        data: dates.map((date) => {
          const entry = data.find(
            (d) => d.date === date && d.service === service
          )
          return entry ? entry.count : 0
        }),
      }))

      this.setState({
        options: { ...this.state.options, xaxis: { categories: dates } },
        series,
        loading: false,
      })
    } catch (error) {
      console.error("Error fetching appointment data", error)
      this.setState({ loading: false })
    }
  }

  render() {
    return (
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">Appointments Trend (by Service)</h4>
          <Row className="text-center mt-4">
            <Col xs="12">
              <p className="text-muted">
                Daily appointments grouped by service
              </p>
            </Col>
          </Row>
          <div id="appointment-chart" className="apex-charts" dir="ltr">
            {this.state.loading ? (
              <p>Loading chart...</p>
            ) : (
              <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="area"
                height="350"
              />
            )}
          </div>
        </CardBody>
      </Card>
    )
  }
}

export default MonthlyEarnings
